import { calculateDDay, cn, formatDate } from "@/libs/utils";
import { ProjectInfo } from "@/types/project";
import { ColumnDef } from "@tanstack/react-table";

const cellTextStyle = "text-xs text-gray-A font-normal";

export const bidColumn: ColumnDef<ProjectInfo>[] = [
  {
    header: "공고 제목",
    accessorKey: "title",
    cell: ({ row }) => {
      return (
        <p className={cn(cellTextStyle, "text-sm")}>{row.original.title}</p>
      );
    },
    size: 400,
  },
  {
    header: "발주처",
    accessorKey: "institution_name",
    cell: ({ row }) => {
      return <p className={cellTextStyle}>{row.original.institution_name}</p>;
    },
    size: 135,
  },
  {
    header: () => {
      return <p className="text-right">사업 금액</p>;
    },
    accessorKey: "budget_amount",
    cell: ({ row }) => {
      const bidAmount = row.original.budget_amount || 0;
      if (bidAmount >= 100000000) {
        const eok = (bidAmount / 100000000).toFixed(1);
        return <p className={cn(cellTextStyle, "text-right")}>{eok}억원</p>;
      } else if (bidAmount >= 10000) {
        const eok = Math.floor(bidAmount / 10000);
        return <p className={cn(cellTextStyle, "text-right")}>{eok}만원</p>;
      } else {
        return <p className={cn(cellTextStyle, "text-right")}>{bidAmount}원</p>;
      }
    },
    size: 90,
  },
  {
    header: "공고 게시일",
    accessorKey: "begin_date",
    cell: ({ row }) => {
      const beginDate = row.original.begin_date;
      if (!beginDate) return <p className={cellTextStyle}>-</p>;

      return <p className={cellTextStyle}>{formatDate(beginDate)}</p>;
    },
    size: 150,
  },
  {
    header: "공고 마감일",
    accessorKey: "close_date",
    cell: ({ row }) => {
      const closeDate = row.original.close_date;
      if (!closeDate) return <p className={cellTextStyle}>-</p>;

      const dDay = calculateDDay(closeDate);

      return (
        <p
          className={cn(cellTextStyle, {
            "text-red font-bold": dDay <= 3 && dDay >= 0, // D-3일 이하일 때 빨간색 강조
          })}
        >
          {formatDate(closeDate)}
        </p>
      );
    },
    size: 150,
  },
  {
    id: "select",
    cell: ({ table, row }) => {
      return (
        <input
          type="radio"
          name="select-row"
          checked={row.getIsSelected()}
          onChange={() => {
            table.setRowSelection({
              [row.id]: true,
            });
          }}
          className="h-4 w-4 accent-dark-red"
        />
      );
    },
    size: 60,
  },
];
